import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXfileuploadicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 23,
	viewBox: "0 0 24 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.71429 16.5312C5.93908 16.5312 4.5 15.1684 4.5 13.4871C4.5 11.8059 5.93908 10.443 7.71429 10.443C7.92738 10.443 8.13562 10.4627 8.33712 10.5001M13.7857 8.64456C14.2325 8.49499 14.7134 8.4136 15.2143 8.4136C15.7053 8.4136 16.177 8.4918 16.6163 8.63577M8.33712 10.5001C8.1653 10.0609 8.07143 9.58588 8.07143 9.09007C8.07143 6.84845 9.99021 5.03125 12.3571 5.03125C14.5619 5.03125 16.3778 6.60798 16.6163 8.63577M8.33712 10.5001C8.76044 10.5788 9.15396 10.7363 9.5 10.9556M16.6163 8.63577C18.2947 9.18579 19.5 10.6958 19.5 12.4724C19.5 14.4181 18.0545 16.044 16.125 16.4394",
		stroke: "#009DDB",
		strokeWidth: 1.2,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 14.375V18.6875M12 14.375L13.5 15.8125M12 14.375L10.5 15.8125",
		stroke: "#0009E2",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgXfileuploadicon;
